import React, { Component } from 'react';
import Where from './questions/Where';
import Duration from './questions/Duration';
import Involved from './questions/Involved';
import Source from './questions/Source';

export class ComplaintDetailsSpecific extends Component {

    showWhereOccur = () => {
        if (this.props.typename.indexOf("Other") > -1 || this.props.typename.indexOf("Assault/Fight") > -1) {
            return <Where specificChanges={this.props.incidentSpecificChanges} />;
        }
        return null;
    }

    showIncidentDuration = () => {
        if (this.props.typename.indexOf("Noise") > -1 || this.props.typename.indexOf("Assault/Fight") > -1) {
            return <Duration specificChanges={this.props.incidentSpecificChanges} />;
        }
        return null;
    }

    showWhoInvolved = () => {
        if (this.props.typename.indexOf("Assault/Fight") > -1) {
            return <Involved incidentObj={this.props.incidentObj} specificChanges={this.props.incidentSpecificChanges} />;
        }
        return null;
    }

    showNoiseSource = () => {
        if (this.props.typename.indexOf("Noise") > -1) {
            return <Source specificChanges={this.props.incidentSpecificChanges} />;
        }
        return null;
    }

    render() {
        return (
            <div className="well-sm" >        
                <br />
                {this.showWhereOccur()}

                {this.showWhoInvolved()}

                {this.showIncidentDuration()}

                {this.showNoiseSource()}

            </div>
        );
    }
}

export default ComplaintDetailsSpecific;


// WEBPACK FOOTER //
// ./src/components/ComplaintDetailsSpecific.js